export const getProductsByOperationQuery = `query GetCanonicals ($org_id: String!, $id: String!, $unit_set: String!) {
        operations (
          org_id: $org_id,
          id: $id,
          allocation: {
            is_composite: true
          },
          unit_set: $unit_set
        ) {
          products{
                id
                description,
                is_resolved,
                aliases{
                    id, 
                    instance_system_id, 
                    model_scope,
                    system_type
                },
                product_type,
                product_components{
                    product_ref,
                    is_carrier,
                    quantity{value}
                },
            }
            product_uses{
                resource_ref
                resource_measures{
                    uom
                    dtr_code
                    user_uom
                    value
                },
                mix_components {
                    resource_ref
                    resource_measures {
                        dtr_code
                        uom
                        value
                    }
                }
            }
        }
      }`;
